﻿import HotEditableFormManager = require("./HotEditableFormManager");
import common = require('../../../common');

class SharedEmbeddedParentForm {

    private _currentFormManager: HotEditableFormManager;
    private _childrenFormManagers = [] as HotEditableFormManager[];
    /** le parent dans le cas dune imbrication */
    private _sharedEmbeddedParentForm: SharedEmbeddedParentForm;
    private _hotEmbeddedComponentName: string;

    constructor(hotEmbeddedComponentName: string, currentFormManager: HotEditableFormManager, sharedEmbeddedParentForm: SharedEmbeddedParentForm) {
        this._hotEmbeddedComponentName = hotEmbeddedComponentName;
        this._currentFormManager = currentFormManager;
        this._sharedEmbeddedParentForm = sharedEmbeddedParentForm;
    }

    getEmbeddedComponentName() { return this._hotEmbeddedComponentName; }

    destroyChildren() {
        for (let i = 0; i < this._childrenFormManagers.length; i++)
            this._childrenFormManagers[i].destroyComponents();
        this._childrenFormManagers = [];
        return this;
    }
    addChild(formManager: HotEditableFormManager) {
        if (formManager)
            this._childrenFormManagers.push(formManager);
        return this;
    }
    // Update embedded components
    updateCurrentHotEmbeddedComponent(nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        return this._innerUpdateHotEmbeddedComponent(this.getEmbeddedComponentName(), this.getEmbeddedComponentName(), nextUrl, urlParameters, editModeOn, finalEvalCallback);
    }
    updateHotEmbeddedComponent(name: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        const caller = this.getEmbeddedComponentName();
        this._innerUpdateHotEmbeddedComponent(caller, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        for (let i = 0; i < this._childrenFormManagers.length; i++)
            this._childrenFormManagers[i]._innerUpdateHotEmbeddedComponent(caller, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return this;
    }
    _innerUpdateCurrentHotEmbeddedComponent(embeddedComponentCallerName: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        this._innerUpdateHotEmbeddedComponent(embeddedComponentCallerName, embeddedComponentCallerName, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return this;
    }
    _innerUpdateHotEmbeddedComponent(embeddedComponentCallerName: string, name: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        this._innerUpdateHotEmbeddedComponentRouting(embeddedComponentCallerName, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        for (let i = 0; i < this._childrenFormManagers.length; i++)
            this._childrenFormManagers[i]._innerUpdateHotEmbeddedComponent(embeddedComponentCallerName, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        return this;
    }
    private _innerUpdateHotEmbeddedComponentRouting(embeddedComponentCallerName: string, name: string, nextUrl?: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void) {
        if (this._sharedEmbeddedParentForm)
            this._sharedEmbeddedParentForm._innerUpdateHotEmbeddedComponentRouting(embeddedComponentCallerName, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
        this._currentFormManager._innerUpdateHotEmbeddedComponent(embeddedComponentCallerName, name, nextUrl, urlParameters, editModeOn, finalEvalCallback);
    }
    getHotEmbeddedComponentByName(name: string) {
        return this._currentFormManager.getHotEmbeddedComponentByName(name);
    }
    refreshBrotherEmbeddedComponents(currentEmbeddedComponentName: string) {
        this._currentFormManager.refreshBrotherEmbeddedComponents(currentEmbeddedComponentName);
        return this;
    }
    isParentOf(componentName: string) {
        if (this.getEmbeddedComponentName() === componentName)
            return true;
        return this._sharedEmbeddedParentForm && this.isParentOf(this.getEmbeddedComponentName());
    }
    hasParent(componentName: string) {
        if (!this._sharedEmbeddedParentForm)
            return false;
        if (this._sharedEmbeddedParentForm.getEmbeddedComponentName() === componentName)
            return true;
        return this._sharedEmbeddedParentForm.hasParent(componentName);
    }
    hasEditionEmbeddedForm() {
        if (this._currentFormManager.hasEditionEmbeddedForm())
            return true;
        for (let i = 0; i < this._childrenFormManagers.length; i++)
            if (this._childrenFormManagers[i].hasEditionEmbeddedForm())
                return true;
        if (this._sharedEmbeddedParentForm && this._sharedEmbeddedParentForm.hasEditionEmbeddedForm())
            return true;
        return false;
    }
    getEmbeddedContentModels(clause?: (model: common.IEmbeddedContentModel) => boolean) {
        return this._currentFormManager.getEmbeddedContentModels(clause);
    }
    showHotEmbeddedComponentsByCategory(category: string, isVisible?: boolean) {
        this._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        for (let i = 0; i < this._childrenFormManagers.length; i++)
            this._childrenFormManagers[i]._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        return this;
    }
    private _innerShowHotEmbeddedComponentsByCategory(category: string, isVisible?: boolean) {
        if (this._sharedEmbeddedParentForm)
            this._sharedEmbeddedParentForm._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
        this._currentFormManager._innerShowHotEmbeddedComponentsByCategory(category, isVisible);
    }
    countHotEmbeddedComponentsByCategory(category: string) {
        var count = this._innerCountHotEmbeddedComponentsByCategory(category);
        for (let i = 0; i < this._childrenFormManagers.length; i++)
            count += this._childrenFormManagers[i]._innerCountHotEmbeddedComponentsByCategory(category);
        return count;
    }
    private _innerCountHotEmbeddedComponentsByCategory(category: string) {
        var count = this._currentFormManager._innerCountHotEmbeddedComponentsByCategory(category);
        if (this._sharedEmbeddedParentForm)
            count += this._sharedEmbeddedParentForm._innerCountHotEmbeddedComponentsByCategory(category);
        return count;
    }
}

export = SharedEmbeddedParentForm;